import { RetailerApiClient } from '@/services/RetailerApiClient.js'

export default {
  getSalesChannel(id, salesChannelId) {
    return RetailerApiClient.get('retailers/' + id + '/sales-channels/' + salesChannelId)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getSalesChannels(id) {
    return RetailerApiClient.get('retailers/' + id + '/sales-channels')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getCategories() {
    return RetailerApiClient.get('retailer-categories')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  editRetailer(retailer) {
    return RetailerApiClient.patch('retailers/update', retailer)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getRetailer() {
    return RetailerApiClient.get('retailer')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  checkBrands() {
    return RetailerApiClient.get('brand-check')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getMobileProducts(tradeType) {
    return RetailerApiClient.get('mobile-products', {
      params: { trade_type: tradeType }
    })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  removeMobileProduct(retailerMobileProductId) {
    return RetailerApiClient.delete('mobile-products/' + retailerMobileProductId + '/delete')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  sendRequestMobileAddProduct(productId) {
    return RetailerApiClient.post('requested-mobile-product', {
      product_id: productId
    })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  checkRequestedMobileProduct(retailerId) {
    return RetailerApiClient.get('requested-mobile-product', {
      params: retailerId
    })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  fetchProductPriceRange(productUnitId) {
    return RetailerApiClient.post('products/price-range', {
      product_unit_id: productUnitId
    })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getRetailerContacts() {
    return RetailerApiClient.get('contacts')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  saveRetailerContact(contact) {
    return RetailerApiClient.post('contacts', contact)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  deleteRetailerContact(contactId) {
    return RetailerApiClient.delete('contacts/' + contactId)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  updateRetailerContact(contactId, contact) {
    return RetailerApiClient.patch('contacts/' + contactId, contact)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
}
